import React from 'react';
import { HeroVariant21 } from '../components/HeroVariant21';
import { Services } from '../components/Services';
import { WhyUs } from '../components/WhyUs';
import { FAQ } from '../components/FAQ';
import { Testimonials } from '../components/Testimonials';
import { Consultation } from '../components/Consultation';
import { CookieBanner } from '../components/CookieBanner';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { FloatingContact } from '../components/FloatingContact';
export function LandingPage21() {
  return <div className="min-h-screen w-full" style={{
    backgroundColor: 'var(--bg-primary)'
  }} data-id="element-1513">
      <Navigation data-id="element-1514" />
      <main data-id="element-1515">
        <HeroVariant21 data-id="element-1516" />
        <WhyUs data-id="element-1517" />
        <Services data-id="element-1518" />
        <FAQ data-id="element-1519" />
        <Testimonials data-id="element-1520" />
        <Consultation data-id="element-1521" />
      </main>
      <Footer data-id="element-1522" />
      <CookieBanner data-id="element-1523" />
      <FloatingContact data-id="element-1524" />
    </div>;
}